import React from 'react';
import PriceDiff from './components/PriceDiff';
import MinPriceUrl from './components/MinPriceUrl';
import OwnUrl from './components/OwnUrl';
import { AdRow } from './styles';
import { HeaderPrice } from './components/PriceDiff/styles';
import { HeaderMinPrice } from './components/MinPriceUrl/styles';
import { HeaderOwn } from './components/OwnUrl/styles';

class Header extends React.Component {

  render = () => (
    <AdRow>
      <HeaderPrice>Árkülönbség</HeaderPrice>
      <HeaderMinPrice>Konkurens hirdetés</HeaderMinPrice>
      <HeaderOwn>Saját hirdetés</HeaderOwn>
    </AdRow>
  );

}

class Ad extends React.Component {

  render = () => (
    <AdRow>
      <PriceDiff priceDiff={this.props.ad.priceDiff} />
      <MinPriceUrl
        url={this.props.ad.minPriceUrl}
        phoneNumber={this.props.phoneNumber}
        priceDiff={this.props.ad.priceDiff} />
      <OwnUrl
        url={this.props.ad.ownUrl}
        phoneNumber={this.props.phoneNumber}
        priceDiff={this.props.ad.priceDiff} />
    </AdRow>
  );

}

export {
  Header,
  Ad
}



// WEBPACK FOOTER //
// ./src/components/AdList/components/Ad/index.js